import { MutationUpdaterFn } from 'apollo-client';
import { ME } from '../../graphql/account/query';
import { Me } from '../../graphql/account/types/Me';
import { DocumentInterface } from '../../interface/DocumentInterface';
import { FileInterface } from '../../interface/FileInterface';
import { INDIVIDUAL_LEGALFORM } from '../../utils/legalForm';
import { IStepFive } from '../../interface/StepFive';
import moment from 'moment';
import { TreezorDocType, CIN_ENUM } from '../../utils/constant';
import { SelectItemInterface } from '../../interface/SelectItemInterface';
import { CreatePerson } from '../../graphql/person/types/CreatePerson';

const CIN1 = "Carte Nationale d'identité";
const CIN2 = `Carte Nationale d'Identité`;

export interface CreateHostInterface {
  identity: string;
  address: string;
}

export let document: DocumentInterface = {
  id: '',
  uuid: '',
  filename: '',
  filetype: '',
  documentTypeId: '',
};
export const handleUpdateCacheAfterManagerCreation: MutationUpdaterFn<
  CreatePerson
> = (cache, result) => {
  const { data } = result;
  if (data?.createPerson) {
    const meData = cache.readQuery<Me>({ query: ME });
    if (meData?.me?.company?.leader) {
      const identityDocument: DocumentInterface[] = getDocs(
        data.createPerson,
        TreezorDocType.IDENTITY_DOC,
      );
      const vigilanceDocument: DocumentInterface[] = getDocs(
        data.createPerson,
        TreezorDocType.VIGILANCE_SUP_DOC,
      );
      const addressProofDocument: DocumentInterface = getDocs(
        data.createPerson,
        TreezorDocType.ADDRESS_PROOF_DOC,
      )[0];
      const hostIdentityDocument: DocumentInterface[] = getDocs(
        data.createPerson,
        TreezorDocType.HOSTING_PROOF_IDENTITY,
      );
      const hostAddressDocument: DocumentInterface = getDocs(
        data.createPerson,
        TreezorDocType.HOSTING_PROOF_ADDRESS,
      )[0];
      const hostAttestationDocument: DocumentInterface = getDocs(
        data.createPerson,
        TreezorDocType.HOSTING_PROOF_ATTESTATION,
      )[0];

      data.createPerson.documents = [
        ...identityDocument,
        ...vigilanceDocument,
        { ...addressProofDocument },
        ...hostIdentityDocument,
        { ...hostAddressDocument },
        { ...hostAttestationDocument },
      ].map((_d) => {
        return {
          ..._d,
          __typename: 'Document',
          type: {
            id: _d.documentTypeId,
            name: '',
            __typename: 'DocumentType',
            category: _d.category,
          },
        };
      }) as any;

      meData.me.company.leader = data.createPerson;
      if (cache) {
        cache.writeQuery<Me>({
          query: ME,
          data: meData,
        });
      }
    }
  }
};
// initiate variable
export const initDoc: FileInterface = {
  filename: '',
  filetype: '',
  file: [],
};

export const canNotAddShareholders = (
  legalFormLabel: string | null,
): boolean => {
  return legalFormLabel ? INDIVIDUAL_LEGALFORM.includes(legalFormLabel) : false;
};

export const dataInitialStepFive: IStepFive = {
  id: '',
  identity: 0,
  identity2: 0,
  addressProof: 0,
  type: '',
  specifiedUSPerson: false,
  isPersonHosted: false,
  title: '',
  name: '',
  firstName: '',
  nationality: 'FR',
  birthday: moment(moment().subtract(18, 'year')).toDate(),
  placeOfBirth: '',
  birthCountry: 'FR',
  birthPostCode: '',
  gender: '',
  address: '',
  postCode: '',
  city: '',
  documents: [],
  incomeRange: '',
  country: 'FR',
};

export const getDocs = (
  information: any,
  category: string,
  isCin?: string,
): DocumentInterface[] => {
  if (information && information.documents) {
    const docs = information.documents.filter((doc: any) => {
      return doc && doc.category === category;
    });
    if (docs && docs.length) {
      // if CIN document only
      if (isCin) {
        switch (isCin) {
          case CIN_ENUM.RECTO:
            if (docs[0]) {
              return [{ ...docs[0] }];
            } else {
              return [{ ...document }];
            }
          case CIN_ENUM.VERSO:
            if (docs[1]) {
              return [{ ...docs[1] }];
            } else {
              return [{ ...document }];
            }
          default:
            return [{ ...document }];
        }
      }
      // if other document
      return docs;
    }
  }
  return [{ ...document }];
};

export const getHostFile = (
  _files: FileInterface[],
  category: string,
): FileInterface[] | null => {
  const files = [..._files];
  const file = files.filter(
    (_fil) => _fil && _fil.category && _fil.category === category,
  );
  if (file) return file;
  return null;
};

export const removeCategory = (documents: DocumentInterface[]) => {
  return documents
    .map((docs: any) => {
      delete docs.category;
      delete docs.type;
      delete docs.__typename;
      return docs;
    })
    .filter((d) => d && d.filename && d.filename.length > 0);
};
export const isCIN = (
  docTypeId: string,
  identityIItems: SelectItemInterface[],
) => {
  const result = identityIItems.filter((i) => i && i.id === docTypeId);
  if (result && result[0]) {
    if (CIN1 === result[0].label || result[0].label === CIN2) {
      return true;
    }
  }
  return false;
};
